forms = {
    init: function () {
        let iFs = document.querySelectorAll( 'input[type="text"], textarea' );  

        for ( let i = 0; i < iFs.length; i++ ) {

            iFs[ i ].addEventListener( 'focus', this.focusLabel, {passive: true} )
            iFs[ i ].addEventListener( 'focusout', this.focusOutLabel, {passive: true} )
            iFs[ i ].addEventListener( 'change', this.updateLabelSize, {passive: true} )

            //this.setLabelSize( iFs[ i ] );
        }
    },

    setLabelSize: function ( iF ) {
        let sibl = iF.parentNode.parentNode.querySelector( 'label' );

        if ( iF.value !== '' ) {
            sibl.classList.add( 'active' )
        } else {
            sibl.classList.remove( 'active' )
        }
    }, 

    focusLabel: function ( event ) {
        let iF = event.target;
        let sibl = iF.parentNode.parentNode.querySelector( 'label' );
        sibl.classList.add( 'active' )
    },

    focusOutLabel: function ( event ) {
        let iF = event.target;

        let sibl = iF.parentNode.parentNode.querySelector( 'label' );

        if ( iF.value !== '' ) {
            sibl.classList.add( 'active' )
        } else {
            sibl.classList.remove( 'active' )
        }
    }, 

    updateLabelSize: function ( event ) {
        let iF = event.target;
        let sibl = iF.parentNode.parentNode.querySelector( 'label' );

        if ( iF.value !== '' ) {
            sibl.classList.add( 'active' )
        } else {
            sibl.classList.remove( 'active' )
        }
    }
}